module.exports = __webpack_public_path__ + "img/icon_note_yellow.fe27e222.svg";